import axios from 'axios'

export class TemplatesService {
  getTemplates () {
    return axios.get(`${process.env.VUE_APP_BACKEND_URL}/templates`).then(r => r.data)
  }
}

export default new TemplatesService()
